export class TemplateData {
  text: string;
  templateFields: Array<string>;
  renderedText: string;
  templateId: number;
}
